<template>
    <common-button
        v-bind="referralButtonProps"
        :isFluid="true"
        :size="getButtonSize"
        @click="performAction($event)"
    ></common-button>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            type: { type: String, required: true },
            referral: { type: Object, required: true },
        },

        inject: {
            isReferralPool: {
                default: false,
            },
        },

        computed: {
            referralButtonProps() {
                if (this.isReferralPool) {
                    let defaultProps = {
                        type: 'secondary',
                        label: this.$t('pages.referrals.index.buttons.view_referral'),
                        route: { name: `referrals.${this.type}.pool.show`, params: { id: this.referral.id } },
                    }

                    if (this.type === 'received') {
                        const statuses = {
                            CREATED: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.respond'),
                                route: { name: `referrals.${this.type}.pool.show`, params: { id: this.referral.id } },
                            },
                            SCHEDULED: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.view_referral'),
                                route: { name: `referrals.${this.type}.show`, params: { id: this.referral?.referralId } },
                            },
                        }

                        return statuses[this.referral.status] || defaultProps
                    }

                    if (this.type === 'made') {
                        if (this.referral.isTemporary) {
                            return {
                                type: 'secondary',
                                label: this.$t('pages.referrals.index.buttons.view_referral'),
                                route: { name: `referrals.${this.type}.temporary.show`, params: { id: this.referral?.id } },
                            }
                        }
                        const statuses = {
                            SCHEDULED: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.view_referral'),
                                route: { name: `referrals.${this.type}.show`, params: { id: this.referral?.referralId } },
                            },
                            TIME_SLOTS_PROPOSED: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.select_time_slot'),
                                route: { name: `referrals.${this.type}.pool.show`, params: { id: this.referral?.id } },
                            },
                        }
                        return statuses[this.referral.status] || defaultProps
                    }

                    return defaultProps
                } else {
                    let defaultProps = {
                        type: 'secondary',
                        label: this.$t('pages.referrals.index.buttons.view_referral'),
                        route: { name: `referrals.${this.type}.show`, params: { id: this.referral.id } },
                    }

                    if (this.type === 'received') {
                        const statuses = {
                            CREATED: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.respond'),
                                route: {
                                    name: this.referral.referralInfo?.isTemporary
                                        ? `referrals.${this.type}.temporary.show`
                                        : `referrals.${this.type}.show`,
                                    params: { id: this.referral.id },
                                },
                            },
                            CONSULTATION_NOTES_PENDING: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.add_notes'),
                                route: { name: `referrals.received.add-report`, params: { id: this.referral.id } },
                            },
                            RESCHEDULE_REQUESTED_BY_PATIENT: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.propose_new_slots'),
                                route: {
                                    name: `referrals.${this.type}.propose`,
                                    params: { referralId: this.referral.id },
                                    query: {
                                        physicianId: this.referral?.toUser?.id,
                                        userId: this.referral?.toUser?.id,
                                        practiceId: this.referral.practice?.id,
                                        practiceLocation: this.referral.practiceLocation,
                                        fromUserId: this.referral.fromUser?.id,
                                        practiceType: this.referral.practice?.practiceType,
                                    },
                                },
                            },
                        }
                        return statuses[this.referral.status] || defaultProps
                    }

                    if (this.type === 'made') {
                        const statuses = {
                            RESCHEDULE_REQUESTED_BY_PATIENT: {
                                type: 'primary',
                                label: this.$t('pages.referrals.index.buttons.view_referral'),
                                route: { name: `referrals.${this.type}.show`, params: { id: this.referral?.id } },
                            },
                        }

                        return statuses[this.referral.status] || defaultProps
                    }

                    return defaultProps
                }
            },

            getButtonSize() {
                return this.isTabletSmall ? 'small' : 'large'
            },
        },

        methods: {
            performAction() {},
        },
    }
</script>
